import { List } from "immutable";
import { AiseaApiFactory } from "@/api/aisea/apiFactory";
const ConstantResource = AiseaApiFactory.get("constantRepository");

const state = {
  country_code_version: null,
  phone_number_version: null,
  prefecture_version: null,
  country_codes: List(),
  phone_numbers: List(),
  prefectures: List()
};

const mutations = {
  setCountryCode: (state, payload) => {
    state.country_code_version = payload.version;
    state.country_codes = List(payload.country_codes);
  },
  setPhoneNumber: (state, payload) => {
    state.phone_number_version = payload.version;
    state.phone_numbers = List(payload.locale_phone_numbers);
  },
  setPrefecture: (state, payload) => {
    state.prefecture_version = payload.version;
    state.prefectures = List(payload.prefectures);
  }
};

const actions = {
  getCountryName: (context, countryCode) => {
    if (countryCode) {
      let cc = context.state.country_codes.filter(
        country => country.id === countryCode
      );
      return cc.size > 0 ? cc.get(0).name_localized : null;
    } else {
      return null;
    }
  },
  getCountryCodes: context => {
    if (context.state.country_codes.size > 0) {
      return Promise.resolve();
    }

    return ConstantResource.fetchCountryCode().then(d => {
      context.commit("setCountryCode", d.data);
    });
  },
  getPhoneNumbers: context => {
    if (context.state.phone_numbers.size > 0) {
      return Promise.resolve();
    }

    return ConstantResource.fetchPhoneNumber().then(d => {
      context.commit("setPhoneNumber", d.data);
    });
  },
  getPrefectures: context => {
    if (context.state.prefectures.size > 0) {
      return Promise.resolve();
    }

    return ConstantResource.fetchPrefecture().then(d => {
      context.commit("setPrefecture", d.data);
    });
  }
};

const getters = {
  getCountryCodes: state => {
    return state.country_codes.asImmutable().toJS();
  },
  getPhoneNumbers: state => {
    return state.phone_numbers.asImmutable().toJS();
  },
  getPrefectures: state => {
    return state.prefectures.asImmutable().toJS();
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};
